const defaultTakeValue = 1500;
const extraTakeValue = 1500;
const convertTimeFor = 1000;
export const marketDataRoutes = {
  getCandleBars: (symbol: string, period: string, fromTime: number) =>
    `/market-data/bars?symbol=${symbol}&period=${period}&take=${
      !fromTime ? defaultTakeValue : extraTakeValue
    }${
      fromTime
        ? `&fromTime=${new Date(fromTime * convertTimeFor).toISOString()}`
        : ''
    }`,
  getIndicators: (symbol: string) => `/market-data/indicators?symbol=${symbol}`,
} as const;
